// Based on Facebook's implementation
define('utils/hide_plugin',['underscore', 'easyXDM/easyXDM', 'rpc', 'event'], function(_, XDM, RPC, Event) {
  var flashClassID = 'CLSID:D27CDB6E-AE6D-11CF-96B8-444553540000';
  var unityClassID = 'CLSID:444785F1-DE89-4295-863A-D46C3A781394';
  var devHidePluginCallback = null;

  function hideUnityElement(elem) {
    elem._hideunity_savedstyle = {};
    elem._hideunity_savedstyle.left = elem.style.left;
    elem._hideunity_savedstyle.position = elem.style.position;
    elem._hideunity_savedstyle.width = elem.style.width;
    elem._hideunity_savedstyle.height = elem.style.height;
    elem.style.left = '-10000px';
    elem.style.position = 'absolute';
    elem.style.width = '1px';
    elem.style.height = '1px';
  }

  function showUnityElement(elem) {
    if (elem._hideunity_savedstyle) {
      elem.style.left     = elem._hideunity_savedstyle.left;
      elem.style.position = elem._hideunity_savedstyle.position;
      elem.style.width    = elem._hideunity_savedstyle.width;
      elem.style.height   = elem._hideunity_savedstyle.height;
    }
  }

  function hideFlashElement(elem) {
    elem._old_visibility = elem.style.visibility;
    elem.style.visibility = 'hidden';
  }

  function showFlashElement(elem) {
    elem.style.visibility = elem._old_visibility || '';
    delete elem._old_visibility;
  }

  function isHideableFlashElement(elem) {
    var type = elem.type ? elem.type.toLowerCase() : null;

    var isHideable = type === 'application/x-shockwave-flash' ||
      (elem.classid && elem.classid.toUpperCase() == flashClassID);

    if (!isHideable) {
      return false;
    }

    // for flash elements we don't need to hide if it is in wmode
    var keepvisibleRegex = /opaque|transparent/i;
    if (keepvisibleRegex.test(elem.getAttribute('wmode'))) {
      return false;
    }

    for (var j = 0; j < elem.childNodes.length; j++) {
      var node = elem.childNodes[j];
      if (/param/i.test(node.nodeName) && /wmode/i.test(node.name) &&
      keepvisibleRegex.test(node.value)) {
        return false;
      }
    }
    return true;
  }

  function isHideableUnityElement(elem) {
    var type = elem.type ? elem.type.toLowerCase() : null;
    return type === 'application/vnd.unity' ||
      (elem.classid && elem.classid.toUpperCase() == unityClassID);
  }

  function hidePluginCallback(params) {
    var candidates = _.union(_.toArray(window.document.getElementsByTagName('object')), _.toArray(window.document.getElementsByTagName('embed')));

    _.each(candidates, function(element) {
      var isFlashElement = isHideableFlashElement(element);
      var isUnityElement = isHideableUnityElement(element);
      if (!isFlashElement && !isUnityElement) {
        return;
      }

      var visibilityToggleCallback = function() {
        if (params.state === 'opened') {
          if (isFlashElement) {
            hideFlashElement(element);
          } else if (isUnityElement) {
            hideUnityElement(element);
          }
        } else {
          if (isFlashElement) {
            showFlashElement(element);
          } else if (isUnityElement) {
            showUnityElement(element);
          }
        }
      };

      if (devHidePluginCallback) {
        var devArgs = { state : params.state, element : element };
        devHidePluginCallback(devArgs);
        setTimeout(visibilityToggleCallback, 200);
      } else {
        visibilityToggleCallback();
      }
    });
  }

  function hidePluginElement(element) {
    if(isHideableFlashElement(element))
      hideFlashElement(element);
    else if(isHideableUnityElement(element))
      hideUnityElement(element);
  }

  function showPluginElement(element) {
    if(isHideableFlashElement(element))
      showFlashElement(element);
    else if(isHideableUnityElement(element))
      showUnityElement(element);
  }

  function hidePluginObjects() {
    hidePluginCallback({state: 'opened'});
  }

  function showPluginObjects() {
    hidePluginCallback({state: 'closed'});
  }

  // TODO: Facebook uses RPC to call these methods, investigate why
  Event.subscribe('dialog.show', hidePluginObjects);
  Event.subscribe('dialog.hide', showPluginObjects);

  return {
    _setHidePluginCallback: function(callback) {
      devHidePluginCallback = callback;
    },
    hidePluginElement: hidePluginElement,
    showPluginElement: showPluginElement,
    hidePluginObjects: hidePluginObjects,
    showPluginObjects: showPluginObjects
  };
});

